import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';

import ExpandableSection from 'widgets/ExpandableSection/ExpandableSection';

import { getCatalogueLink } from 'apps/catalogue/links';

const renderTag = ((tag, index, tags) => (
  <li key={tag.id} className="bop-categoryTag">
    <Link
      className="bop-categoryTagLabel"
      to={getCatalogueLink({ category: tags.slice(0, index + 1) }, '/browse')}
    >
      {tag.name}
    </Link>
  </li>
));

const renderCategories = (categories) => {
  if (!Array.isArray(categories)) {
    return null;
  }

  return categories
    .filter(category => category.tags && category.tags.length)
    .map((category, index) => (
      <ul
        key={index} // eslint-disable-line
        className="bop-categoriesList"
      >
        {category.tags.map(renderTag)}
      </ul>
    ));
};
const renderGroupItem = (item) => (
  <Link
    key={`tag-${item.name}`}
    className={classNames(
      'bop-tag',
      { 'bop-tag--onOffer': ['On Offer', 'Top Offers'].includes(item.name) }
    )}
    to={getCatalogueLink({ category: [item] }, '/browse')}
  >
    {item.name}
  </Link>
);

const renderGroups = (groups) => (
  <ul className="bop-tagsList">
    {groups && Object.keys(groups).map(groupName => (
      <li key={`tagLabel-${groupName}`} className="bop-tags">
        <span className="bop-tagLabel">{groupName}</span>
        <div className="bop-tagsWrapper">
          {groups[groupName].map(renderGroupItem)}
        </div>
      </li>
    ))
    }
  </ul>
);

export default function Categories({ tags }) {
  if (!tags) {
    return null;
  }
  const { categories, groups } = tags;
  const tagCategoriesExist = categories && categories.length;
  const tagsGroupsExist = groups && Object.keys(groups).length;

  if (!tagCategoriesExist && !tagsGroupsExist) {
    return null;
  }

  return (
    <section id="categories" className="bop-section bop-categoriesAndTags">
      <h3>Categories</h3>
      <div className="gn-divider bop-productInfo__divider" />
      <ExpandableSection collapsedHeight="328px">
        {renderGroups(groups)}
        {renderCategories(categories)}
      </ExpandableSection>
    </section>
  );
}

Categories.defaultProps = {
  tags: {
    categories: [],
    groups: {},
  },
};

Categories.propTypes = {
  tags: PropTypes.shape({
    categories: PropTypes.array,
    groups: PropTypes.object,
  }),
};
